<template>
  <div>
    <div class="page-title">新增作業</div>
    <div class="page-box">
      <jobFrom :formLabelAlign="formLabelAlign" ref="form"></jobFrom>
      <div class="page-button">
        <el-button type="info" @click="onSubmit">提交2</el-button>
        <el-button type="success" @click="backIndexPage">取消</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import {addHomeworks} from '@/api/homeworks'
import jobFrom from "./components/jobFrom.vue";
export default {
  components: { jobFrom },
  data() {
    return {
      formLabelAlign: {
        number: null,
        lang: null,
        gradeId: null,
        grade: {
          name: null,
          price: null,
        },
        startDate: null,
        endDate: null,
        passScore: 0,
        homeworkScopes: [],
        students: [],
      },
    };
  },
  methods: {
    onSubmit() {
      this.$refs.form.$refs.form.validate((valid) => {
        if (valid) {
             this.addHomeworks()
          }
        }) 
    },
    addHomeworks(){
      addHomeworks(this.formLabelAlign).then(()=>{
          this.$message({
            message: '新增成功',
            type: 'success',
          })
          this.$router.push({ name: 'job' })
      })
    },
    backIndexPage() {
      this.$router.push('/job')
    }
  },
};
</script>

<style lang="scss" scoped>
.page-box {
  padding: 20px;
  background-color: #fff;
  margin-top: 20px;
}
</style>